<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="visible"
    width="606px"
    top="22vh"
    append-to-body
    center
    custom-class="login-dialog dialog-normal"
    @close="onClose"
    @open="onDialogOpen"
  >
    <div class="dialog-content">
      <img src="@/assets/images/login_close.png" alt="" class="login-close" @click="onClose"/>
      <div class="input-container">
        <div class="container-title">手机号登录</div>
        <div class="login-container">
          <div class="login-container-l">
            <el-form ref="loginForm" :model="form" :rules="rules" class="login-form">
              <el-form-item prop="phone">
                <el-input
                  v-model="form.phone"
                  maxlength="11"
                  placeholder="请输入手机号"
                  size="default"
                  style="width: 328px;"
                >
                  <template v-slot:prefix>
                    <img class="login-input-icon" src="@/assets/images/login-phone.png"/>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="code">
                <el-input
                  v-model="form.code"
                  maxlength="6"
                  placeholder="请输入验证码"
                  size="default"
                  style="width: 328px;"
                >
                  <el-button slot="suffix" :disabled="timeCount > 0" class="code-btn" type="text" @click="showImgCode">
                    {{ codeText }}
                  </el-button>
                  <template v-slot:prefix>
                    <img class="login-input-icon" src="@/assets/images/login-varfcode.png"/>
                  </template>
                </el-input>
                <div v-if="showVerifyCodeError" class="el-form-item__error">{{ verifyCodeErrorTxt }}</div>
              </el-form-item>
            </el-form>
            <div class="login-btn" @click="onLogin">登录</div>
            <template v-if="!isHeroGame">
              <el-divider>
                <span class="other-login-title">其他方式登录</span>
              </el-divider>
              <div class="other-login-box">
                <a class="qq-btn" @click="onQQWeChatLogin('qq')"></a>
                <a v-if="device.desktop" class="weixin-btn" @click="onQQWeChatLogin('wechat')"></a>
              </div>
            </template>
          </div>
          <div class="login-container-r">
            <div class="wechat-code">
              <!--TODO：暂时修改为微信登录-->
              <div id="__wechat_login_QRCode__" class="iframe-wrap"></div>
               <!--<img v-if="wxSyncLoginQrcodeImg" :src="wxSyncLoginQrcodeImg" alt=""/>
              <span v-else>加载中...</span>-->
              <div class="wechat-login-success" v-if="wxSyncLoginSuccess">
                <i class="el-icon el-icon-success"></i>
                <div class="text">授权成功</div>
              </div>
            </div>
            <!--TODO：暂时修改为微信登录-->
            <!--<p class="wechat-text" @click="getWxSyncLogin()">小程序登录</p>-->
            <p class="wechat-text" @click="getWxSyncLogin()">微信登录</p>
          </div>
        </div>
      </div>
      <div class="login-sign">
        <el-checkbox v-model="isChecked"/>
        登录/扫码 表示您已阅读并同意 注册即代表同意
        <a class="" :href="`//www.${wikiDomain}/wiki/91660.html`" target="_blank">
          《Gamekee隐私政策》
        </a>
        和
        <a :href="`//www.${wikiDomain}/wiki/155685.html`" target="_blank">
          《用户协议》
        </a>
      </div>
    </div>
    <!--<div class="login-body">
      <div class="phone-login">
        <div class="login-type-title">手机登录</div>
        <el-form ref="loginForm" :model="form" :rules="rules" class="login-form">
          <el-form-item prop="phone">
            <el-input
              v-model="form.phone"
              maxlength="11"
              placeholder="请输入手机号"
              size="default"
              style="width: 290px;"
            >
              <template v-slot:prefix>
                <img class="login-input-icon" src="@/assets/images/login-phone.png" />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input v-model="form.code" maxlength="6" placeholder="请输入验证码" size="default" style="width: 290px;">
              <el-button slot="suffix" :disabled="timeCount > 0" class="code-btn" type="text" @click="showImgCode">
                {{ codeText }}
              </el-button>
              <template v-slot:prefix>
                <img class="login-input-icon" src="@/assets/images/login-varfcode.png" />
              </template>
            </el-input>
            <div v-if="showVerifyCodeError" class="el-form-item__error">{{ verifyCodeErrorTxt }}</div>
          </el-form-item>
        </el-form>
        <template v-if="!isHeroGame">
          <el-divider>
            <span class="other-login-title">其他方式登录</span>
          </el-divider>
          <div class="other-login-box">
            <a class="qq-btn" @click="onQQWeChatLogin('qq')"></a>
            <a v-if="device.desktop" class="weixin-btn" @click="onQQWeChatLogin('wechat')"></a>
          </div>
        </template>
        <el-button class="login-submit" size="default" type="primary" @click="onLogin">
          登 录
        </el-button>
      </div>
      <div v-loading="wechatQRCodeLoading" class="wechat-login">
        <div class="login-type-title">微信登录</div>
        <div class="qrcode-container">
          <div id="__wechat_login_QRCode__" class="iframe-wrap"></div>
        </div>
      </div>
    </div>
    <div class="xy">
      <el-checkbox v-model="isChecked" />
      登录/扫码 表示您已阅读并同意
      <a class="" :href="`//www.${wikiDomain}/wiki/91660.html`" target="_blank">
        《Gamekee隐私政策》
      </a>
      和
      <a :href="`//www.${wikiDomain}/wiki/155685.html`" target="_blank">
        《用户协议》
      </a>
    </div>-->
    <!-- 阿里云弹出式验证码 -->
    <div id="aliyun-captcha-btn"></div>
    <div id="aliyun-captcha-element"></div>
    <!-- 图形验证码 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="imgCodeVisible"
      :width="device.desktop ? '300px' : '75%'"
      append-to-body
      center
      custom-class="login-dialog dialog-verify"
      top="20vh"
    >
      <div slot="title" class="login-title">请输入图片验证码</div>
      <el-form ref="imgForm" :model="form" :rules="rules" class="login-form">
        <el-form-item>
          <el-row justify="space-between" type="flex">
            <el-col :span="14" class="img-box">
              <img :src="imgSrc" alt="" class="captcha-img"/>
            </el-col>
            <el-col :span="8">
              <span class="reset-img-btn" @click="getCaptcha">换一张</span>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item prop="img_code">
          <el-input v-model="form.img_code" maxlength="6" placeholder="请输入图形验证码" size="default"/>
        </el-form-item>
      </el-form>

      <el-button class="W100" size="default" type="primary" @click="sendSmsCode">
        确定
      </el-button>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="protocolDialog"
      :show-close="false"
      width="340px"
      top="40vh"
      append-to-body
      center
      custom-class="login-dialog protocol-dialog"
    >
      <div style="color: #666666; line-height: 17px; font-size: 12px;">
        <span>登录即默认同意</span>
        <a class="protocol-txt" :href="`//www.${wikiDomain}/wiki/91660.html`" target="_blank">《Gamekee隐私政策》</a>
        <span>和</span>
        <a class="protocol-txt" :href="`//www.${wikiDomain}/wiki/155685.html`" target="_blank">《用户协议》</a>
      </div>
      <template v-slot:title>
        <div style="text-align: left; font-size: 14px; font-weight: bold;">同意Gamekee协议</div>
      </template>
      <template v-slot:footer>
        <div class="footer">
          <div class="no" @click="protocolDialog = false">取消</div>
          <div class="yes" @click="handleAgreeProtocol">确认</div>
        </div>
      </template>
    </el-dialog>
  </el-dialog>
</template>

<script>
import {Message} from "element-ui";
import {apiPublicGetCaptcha, apiPublicSendSmsCode} from "@/api/publicApi";
import {apiQQAuthUrl, apiUserAuth, apiWechatAuthUrl} from "@/api/userApi";
// plugins
import eventBus from "@/plugins/eventBus";
import {setCookies, getCookies} from "../../../plugins/cookies";
import {apiGetWechatMiniAppSyncScheme, apiGetWechatMiniAppSyncLogin} from "@/api/wechatApi";

export default {
  name: "login",
  mixins: [],
  inject: ["getWxaQrcode", "getServiceQrcodeSrc"],
  props: {},
  model: {},
  data() {
    return {
      type: "normal",
      showVerifyCodeError: false,
      verifyCodeErrorTxt: "",
      visible: false,
      NODE_ENV: process.env.NODE_ENV,
      imgCodeVisible: false,
      protocolDialog: false,
      loading: false,
      isChecked: true,
      wxQrcode: "",
      form: {
        phone: "",
        code: "",
        img_code: "",
        is_hero: this.isHeroGame ? 1 : 0
      },
      imgSrc: "",
      wxSyncLoginQrcodeImg: "",
      rules: {
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          },
          {
            pattern: /^[1][0-9]{10}$/,
            message: "手机号不正确",
            trigger: "blur"
          }
        ],
        img_code: [
          {
            required: true,
            message: "请输入手机验证码",
            trigger: "blur"
          }
        ],
        code: [
          {
            required: true,
            message: "请输入短信验证码",
            trigger: "blur"
          }
        ]
      },
      codeText: "获取验证码",
      timeCount: 0,
      wechatQRCodeLoading: false,
      loginType: "",
      captchaId: "",
      // 阿里云验证码
      aliyunCaptchaBtn: null,
      aliyunCaptcha: null,
      timer: null,
      wxSyncLoginSuccess: false
    };
  },
  watch: {},
  beforeMount() {
    if (this.isHeroGame) {
      this.isChecked = true;
    }
    eventBus.$on("onShowLogin", this.onOpen);
  },
  async mounted() {
    const isShowLoginMiniappTips = sessionStorage.getItem("showLoginMiniappTips");

    if (isShowLoginMiniappTips) {
      sessionStorage.removeItem("showLoginMiniappTips");
      if (this.loginUid && this.loginUser.is_bind_min_app) return;
      setTimeout(() => {
        // 提示可前往小程序
        this.$message({
          title: "",
          customClass: "publish-miniapp-tips",
          duration: 0,
          showClose: true,
          message: (
            <div class="miniapp-tips-content">
              <div class="title">
                <img src={require("@/assets/images/ok-icon.png")}/>
                恭喜您 登录成功
              </div>
              <div class="content">
                <div class="qrcode">
                  <img src={this.getServiceQrcodeSrc()} alt="服务号二维码"/>
                </div>
                <div class="tips">
                  <div class="title">扫码关注GameKee服务号</div>
                  <div class="desc">随时接收最新消息</div>
                  <div class="tags">
                    <span>评论回复</span>
                    <span>点赞收藏</span>
                    <span>攻略讨论</span>
                  </div>
                </div>
              </div>
            </div>
          )
        });
        // xxs后关闭
        const duration = this.loginUid && this.loginUser.is_bind_min_app ? 3 * 1000 : 10 * 1000;
        setTimeout(() => {
          Message.closeAll();
        }, duration);
      }, 1000);
    }
  },
  beforeDestroy() {
    // 销毁阿里云验证码
    this.destroyAliyunCaptcha();
    // 销毁登录同步定时器
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    async getWxSyncLogin() {
      this.wxSyncLoginSuccess = false;
      const appMode = process.env.VUE_APP_MODE;
      const params = {
        env_version: appMode === "prod" ? "release" : appMode === "dev" ? "trial" : "trial",
        path: "pages/start/index"
      };
      const res = await apiGetWechatMiniAppSyncScheme(params);
      if (res && res.code === 0) {
        const {scheme, key} = res.data;
        // 保存key
        localStorage.setItem("wx_mini_app_sync_login_key", key);
        console.log(window.btoa(String.fromCharCode(...new Uint8Array(scheme))));
        this.wxSyncLoginQrcodeImg = "data:image/png;base64," + scheme;
        // 轮询登录
        setTimeout(() => {
          this.loopWxSyncLogin();
        }, 2000);
      }
    },
    loopWxSyncLogin() {
      if (this.timer) clearInterval(this.timer);
      const key = localStorage.getItem("wx_mini_app_sync_login_key");
      if (!key) return;
      this.timer = setInterval(() => {
        apiGetWechatMiniAppSyncLogin({key})
          .then(res => {
            if (res && res.code == 0) {
              const {token} = res.data;
              if (token) {
                localStorage.removeItem("wx_mini_app_sync_login_key");
                if (this.timer) clearInterval(this.timer);

                this.$store.commit("set_userToken", token);
                setCookies("userToken", token);
                sessionStorage.setItem("login_status", 1);
                this.wxSyncLoginSuccess = true;
                setTimeout(() => {
                  // 刷新页面
                  window.location.reload();
                }, 1500);
              }
            } else {
              localStorage.removeItem("wx_mini_app_sync_login_key");
              if (this.timer) clearInterval(this.timer);
            }
          })
          .catch(res => {
            localStorage.removeItem("wx_mini_app_sync_login_key");
            if (this.timer) clearInterval(this.timer);
          });
      }, 3000);
    },
    // 展示登录弹窗
    onOpen(type) {
      this.visible = true;
      this.type = type;
      // 进行中
      sessionStorage.setItem("login_status", 0);
      // 初始化阿里云验证码
      this.$nextTick(() => {
        this.initAliyunCaptcha();
        this.getWxSyncLogin();
      });
    },
    onClose() {
      this.visible = false;
      // 去除进行中
      sessionStorage.removeItem("login_status", 0);
      if (this.type === "commentLogin") {
        eventBus.$emit("onCommentLoginClose");
      }
      // 提问登录
      if (this.type === "questionLogin") {
        eventBus.$emit("onQuestionLoginClose");
      }
      // 退出时需要
      const login_jump_path = sessionStorage.getItem("login_jump_path");
      if (login_jump_path) {
        sessionStorage.removeItem("login_jump_path");
      }

      // 销毁阿里云验证码
      this.destroyAliyunCaptcha();
      // 销毁登录同步定时器
      if (this.timer) clearInterval(this.timer);
    },
    initAliyunCaptcha() {
      this.aliyunCaptchaBtn = document.getElementById("aliyun-captcha-btn");
      // 打开阿里云弹出式验证码
      window.initAliyunCaptcha({
        SceneId: "1obfz1o2", // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        prefix: "2aiskc", // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
        mode: "popup", // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
        element: "#aliyun-captcha-element", // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        button: "#aliyun-captcha-btn", // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
        captchaVerifyCallback: this.captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
        onBizResultCallback: this.onBizResultCallback, // 业务请求结果回调函数，无需修改
        getInstance: this.getInstance, // 绑定验证码实例函数，无需修改
        slideStyle: {
          width: 360,
          height: 40
        }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
        language: "cn" // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
      });
    },
    destroyAliyunCaptcha() {
      this.aliyunCaptchaBtn = null;
      this.aliyunCaptcha = null;

      // 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
      if (document.getElementById("aliyunCaptcha-mask")) {
        document.getElementById("aliyunCaptcha-mask").remove();
      }
      if (document.getElementById("aliyunCaptcha-window-popup")) {
        document.getElementById("aliyunCaptcha-window-popup").remove();
      }
    },
    getInstance(instance) {
      this.aliyunCaptcha = instance;
    },
    async captchaVerifyCallback(captchaVerifyParam) {
      console.log(captchaVerifyParam);
      // 1.向后端发起业务请求，获取验证码验证结果和业务结果
      this.captchaId = captchaVerifyParam;
      try {
        const res = await this.sendSmsCode();
        if (res && res.code == 0) {
          const {captcha_result} = res.data;
          if (captcha_result) {
            this.codeText = "60s" + "后重新获取";
            this.timeCount = 60;

            let timer = setInterval(() => {
              if (this.timeCount == 0) {
                this.codeText = "重新获取";
                clearInterval(timer);
                return;
              }
              this.timeCount--;
              this.codeText = this.timeCount + "后重新获取";
            }, 1000);
          }

          return {
            captchaResult: !!captcha_result // 验证码验证是否通过，boolean类型，必选
          };
        }
      } catch (error) {
        return {
          captchaResult: false, // 验证码验证是否通过，boolean类型，必选
          bizResult: false // 业务验证是否通过，boolean类型，可选；若为无业务验证结果的场景，bizResult可以为空
        };
      }
    },
    // 验证通过后调用
    onBizResultCallback() {
      console.log("onBizResultCallback");
    },
    onQQWeChatLogin(type) {
      if (this.loading) return;
      if (!this.isChecked) {
        this.protocolDialog = true;
        this.loginType = type;
        return false;
      }

      let params = {
        state: window.location.href
      };
      this.loading = true;
      let typeApi = {
        qq: apiQQAuthUrl,
        wechat: apiWechatAuthUrl
      };
      typeApi[type](params)
        .then(res => {
          let cookie = "";
          // res.data.url.replace("redirect_uri=https", "redirect_uri=http")
          const win = window.open(res.data.url, "_blank", "width=600,height=400");
          win.moveTo(200, 285);
          const timer = setInterval(() => {
            if (win.closed) {
              clearInterval(timer);
              if (cookie) {
                // 登录完成
                sessionStorage.setItem("login_status", 1);
                location.reload();
              }
            }
          }, 50);
          const checkLogin = () => {
            const c = getCookies("userToken");
            if (c) {
              cookie = c;
              win.close();
            } else {
              setTimeout(checkLogin, 50);
            }
          };
          checkLogin();
        })
        .finally(_ => {
          setTimeout(() => {
            this.loading = false;
          }, 2000);
        });
    },

    showImgCode() {
      if (this.timeCount > 0) return;
      this.$refs.loginForm.validateField(["phone"], err => {
        if (!err) {
          // 开启图形验证码
          // this.getCaptcha();
          // this.imgCodeVisible = true;

          // 阿里云验证码
          this.aliyunCaptchaBtn && this.aliyunCaptchaBtn.click();
        }
      });
      // this.imgCodeVisible = true;
    },
    // 获取短信验证码
    async sendSmsCode() {
      // 检验手机号,验证码
      let isErr = false;
      this.$refs.loginForm.validateField(["phone"], async err => {
        if (err) {
          isErr = true;
        }
      });
      if (isErr || !this.captchaId) return;
      let params = {
        phone: this.form.phone,
        is_hero: this.isHeroGame ? 1 : 0,
        captcha_id: this.captchaId
      };
      return await apiPublicSendSmsCode(params);
    },
    // 获取图形验证码
    getCaptcha() {
      apiPublicGetCaptcha({is_hero: this.isHeroGame ? 1 : 0}).then(res => {
        if (res.code == 0) {
          this.imgSrc = res.data.image_url;
          this.captchaId = res.data.captcha_id;
        }
      });
    },
    loginTips() {
      return new Promise(resolve => {
        const loginTipsStatus = localStorage.getItem("loginTipsStatus");
        if (!loginTipsStatus) {
          this.$alert("打击整治网络水军，让网络空间正气充盈", "公告", {
            showClose: false,
            confirmButtonText: "确定",
            callback: action => {
              localStorage.setItem("loginTipsStatus", true);
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
    },
    onLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (!valid) return;
        if (!this.isChecked) {
          this.protocolDialog = true;
          return false;
        }
        try {
          const {code, data} = await apiUserAuth(this.form);
          if (code == 0) {
            this.$store.commit("set_userInfo", data.user);
            this.$store.commit("set_userToken", data.token);
            this.$store.commit("set_userUid", data.user.uid);

            setCookies("userToken", data.token);
            setCookies("userUid", data.user.uid);
            // 登录完成
            sessionStorage.setItem("login_status", 1);
            sessionStorage.setItem("showLoginMiniappTips", 1);
            // 提示网络水军公告
            // await this.loginTips();
            window.location.reload();
          }
        } catch (error) {
          this.verifyCodeErrorTxt = error.msg;
          this.showVerifyCodeError = true;
          setTimeout(() => {
            this.verifyCodeErrorTxt = "";
            this.showVerifyCodeError = false;
          }, 3000);
        }
      });
    },
    onDialogOpen() {
      this.initWechatQRCode();
    },
    handleAgreeProtocol() {
      this.isChecked = true;
      this.protocolDialog = false;
      if (this.loginType === "") {
        this.onLogin();
      } else {
        this.onQQWeChatLogin(this.loginType);
      }
    },
    async initWechatQRCode() {
      this.wechatQRCodeLoading = true;
      const domEl = () => {
        return new Promise(resolve => {
          const query = () => {
            const el = document.getElementById("__wechat_login_QRCode__");
            if (!el) {
              setTimeout(query, 10);
            } else {
              resolve();
            }
          };
          query();
        });
      };
      await domEl();
      // eslint-disable-next-line no-new , no-undef
      new WxLogin({
        self_redirect: false,
        id: "__wechat_login_QRCode__",
        appid: "wxac6e20a64a95aa01",
        scope: "snsapi_login",
        redirect_uri: encodeURI("https://www.gamekee.com/callback"),
        state: window.location.href,
        stylelite: 1
      });
      setTimeout(() => {
        this.wechatQRCodeLoading = false;
      }, 500);
    }
  }
};
</script>

<style lang="less" scoped>
.login-title {
  font-size: 18px;
  text-align: center;
  position: absolute;
  z-index: 1;
  top: -36px;
  left: 50%;
  transform: translateX(-50%);
}

/deep/ .login-body {
  background-color: #fff;
  border-radius: 20px;
  display: flex;
  margin: 0 2px 35px 2px;

  .login-type-title {
    text-align: center;
    margin-bottom: 14px;
    line-height: 20px;
    color: #000;
  }

  .phone-login {
    padding: 18px 28px;
    width: 290px;
    border-right: 1px solid #e2e2e2;
    box-sizing: content-box;

    .el-form-item {
      margin-bottom: 14px;
    }

    .el-input__inner {
      background-color: #f7f7f7;
      border-color: transparent;
      border-radius: 8px;
    }

    .el-input__inner::-webkit-input-placeholder {
      font-size: 12px;
      color: #c2c2c2;
    }

    .el-divider--horizontal {
      margin-top: 24px;
    }

    .el-input__inner::-moz-placeholder {
      font-size: 12px;
      color: #c2c2c2;
    }

    .login-input-icon {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }

    .login-submit {
      width: 100%;
      border-radius: 100px;
      background-color: #2fceff;
      border: none;
      height: 32px;
      line-height: 32px;
      padding: 0;
    }
  }

  .wechat-login {
    padding-top: 18px;
    width: 230px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .qrcode-container {
      position: relative;
      width: 174px;
      height: 174px;
      background-color: #f7f7f7;

      .iframe-wrap {
        height: 160px;
        width: 160px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        iframe {
          position: absolute;
          left: -68px;
        }
      }
    }
  }
}

.img-box {
  display: flex;
  height: auto;
  height: 40px;
}

.reset-img-btn {
  display: block;
  margin: auto;
  width: 50px;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
  color: #3fa0f4;
  cursor: pointer;
  user-select: none;
}

.captcha-img {
  background: #f5f5f5;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  line-height: 1;
  overflow-x: hidden;
  object-fit: fill;
}

.code-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-weight: 400;
  color: #2fceff;
  right: 7px;

  &:hover {
    color: #2fceff;
  }
}

.other-login-title {
  color: fade(@text-basic, 50%);
  font-weight: 400;
}

/deep/ .xy {
  font-size: 11px;
  line-height: 16px;
  color: @gray;
  cursor: pointer;
  position: absolute;
  bottom: 14px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;

  .el-checkbox__inner,
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #5a75a5;
    border-color: #5a75a5;
    border-radius: 50%;
  }

  a {
    color: #5a75a5;
  }
}
</style>

<style lang="less" scoped>
/deep/ .el-input__prefix {
  display: flex !important;
  align-items: center !important;
}

/deep/ .dialog-normal {
  border-radius: 16px;
  background: transparent;
  border: none;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    width: 100%;
    height: 531px;
    padding: 0;
    background: transparent;
    border: none;

    .dialog-content {
      position: relative;
      width: 100%;
      height: 100%;
      background: transparent url("~@/assets/images/login_bg.png") no-repeat;
      background-size: 100% 100%;

      .login-close {
        position: absolute;
        width: 38px;
        height: 38px;
        top: 0;
        right: 0;
        cursor: pointer;
      }

      .input-container {
        position: absolute;
        left: 5px;
        bottom: 37px;
        width: calc(100% - 10px);
        height: 334px;
        background: url("~@/assets/images/login_bg_content.png") no-repeat;
        background-size: 100% 100%;

        .container-title {
          font-weight: bold;
          font-size: 18px;
          color: rgba(51, 51, 51, 0.7);
          margin: 24px 0 0 147px;
          height: 32px;
        }

        .login-container {
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .login-container-l {
            width: 384px;
            display: flex;
            flex-direction: column;
            align-items: center;

            .login-form {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              .el-form-item {
                margin-bottom: 18px;
              }
            }

            .login-btn {
              width: 328px;
              height: 44px;
              background: url("~@/assets/images/login_btn_bg.png") no-repeat;
              background-size: 100% 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: 500;
              font-size: 16px;
              color: #ffffff;
            }

            .el-divider--horizontal {
              width: 328px;
            }

            .other-login-box {
              display: flex;
              align-items: center;
              justify-content: space-around;
              margin-bottom: 25px;

              a {
                display: flex;
                width: 36px;
                height: 36px;
                background: #f5f5f5;
                border-radius: 50%;
                cursor: pointer;
                border: 1px solid #e8e8e8;

                &.qq-btn {
                  background: url("~@/assets/images/login_qq_btn.png") no-repeat center;
                  background-size: 36px 36px;
                  margin-right: 30px;
                }

                &.weixin-btn {
                  background: url("~@/assets/images/login_wx_btn.png") no-repeat center;
                  background-size: 36px 36px;
                }
              }
            }
          }

          .login-container-r {
            width: 180px;
            height: 240px;
            background: linear-gradient(180deg, #afdeff 0%, #3eafff 100%);
            border-radius: 8px;
            margin: 0 20px 20px 0;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            .wechat-code {
              position: relative;
              width: 162px;
              height: 162px;
              background: #fefefe;
              border-radius: 8px;
              margin-bottom: 15px;
              display: flex;
              align-items: center;
              justify-content: center;

              .iframe-wrap {
                width: 160px;
                height: 160px;

                iframe {
                  width: 160px;
                  height: 160px;
                }
              }

              img {
                width: 146px;
                height: 146px;
              }

              .wechat-login-success {
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                background: rgba(255, 255, 255, 0.8);
                display: flex;
                flex-direction: column;
                gap: 10px;
                align-items: center;
                justify-content: center;
                font-size: 24px;
                color: #34da66;

                .text {
                  font-size: 14px;
                  color: #333;
                }
              }
            }

            .wechat-text {
              width: 83px;
              height: 32px;
              font-weight: bold;
              font-size: 16px;
              color: #ffffff;
              line-height: 32px;
              text-align: center;
            }
          }
        }
      }

      .login-sign {
        font-size: 11px;
        line-height: 16px;
        color: #ffffff;
        cursor: pointer;
        position: absolute;
        bottom: 14px;
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
        display: flex;
        align-items: center;
        justify-content: center;

        .el-checkbox__input.is-checked .el-checkbox__inner {
          background-color: #61c7ff;
          border-color: #61c7ff;
          border-radius: 50%;
          margin-right: 5px;
        }

        .el-checkbox__inner {
          border-radius: 50%;
          margin-right: 5px;
        }

        a {
          color: rgba(34, 34, 34, 1);
        }
      }
    }
  }
}

/deep/ .dialog-verify {
  .login-title {
    position: static;
    transform: translateX(0);
  }
}

/deep/ .protocol-dialog {
  .footer {
    display: flex;
    justify-content: space-between;

    .no,
    .yes {
      width: 45%;
      line-height: 32px;
      text-align: center;
      font-size: 14px;
      border-radius: 4px;
      cursor: pointer;
    }

    .no {
      color: #2fceff;
      background-color: #fff;
      border: 1px solid #2fceff;
    }

    .yes {
      color: #fff;
      background-color: #2fceff;
    }
  }

  .protocol-txt {
    color: #5a75a5;

    &:active {
      color: #5a75a5;
    }
  }
}
</style>
